import { createAction, props } from '@ngrx/store';
import { Activity } from '@shared/models/activity';

export const loadActivitiesSuccess = createAction(
  '[Activities] Load Activities Success',
  props<{ activities: Activity[] }>(),
);
